(function ($) {
	const blockSlug = 'example';
	const initializeBlock = function ($block) {

		// START your JS code

		//$block.find('img').doSomething();
		console.log($block);
		console.log('Example block !!');

		// END your JS code

	};

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		$('acf-block-'+blockSlug).each(function(){

			initializeBlock($(this));

		});
	});

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		// RENAME "type=example" on "type=your_block_slug_name"  ( small caps class name )
		window.acf.addAction('render_block_preview/type='+blockSlug, initializeBlock);
	}
})(jQuery);
